import { useOrganizationPermissions } from 'sierra-client/hooks/use-permissions'

export const useInsightsEnabled = (): boolean => {
  return useOrganizationPermissions().has('ACCESS_ANALYTICS')
}
